import React from 'react';
import { useTranslation } from 'react-i18next';
import { eventCategoryLabelKey } from '../utils/assistanceEventCategories';

/**
 * Cases à cocher + min/max FBU par catégorie d’événement (mécanisme d’allocation).
 */
export default function MechanismCategoryRowsEditor({
  rows,
  onChange,
  disabled = false,
}) {
  const { t } = useTranslation('common');
  const safeRows = Array.isArray(rows) ? rows : [];

  const updateRow = (category, patch) => {
    onChange?.(
      safeRows.map((row) =>
        row.category === category ? { ...row, ...patch } : row
      )
    );
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {t('assistanceManagement.categoriesTitle')}
          </p>
          <p className="mt-0.5 text-xs text-slate-500">
            {t('assistanceManagement.categoriesHint')}
          </p>
        </div>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div className="hidden grid-cols-[minmax(0,1.4fr)_5.5rem_5.5rem] gap-2 border-b border-slate-100 bg-slate-50 px-3 py-2 text-[10px] font-bold uppercase tracking-wide text-slate-500 sm:grid">
          <span>{t('assistanceManagement.tableCategory')}</span>
          <span>{t('assistanceManagement.placeholderMin')}</span>
          <span>{t('assistanceManagement.placeholderMax')}</span>
        </div>
        <ul className="divide-y divide-slate-100">
          {safeRows.map((row) => {
            const label = t(eventCategoryLabelKey(row.category), {
              defaultValue: row.category,
            });
            return (
              <li
                key={row.category}
                className={`grid grid-cols-1 gap-2 px-3 py-2.5 sm:grid-cols-[minmax(0,1.4fr)_5.5rem_5.5rem] sm:items-center ${
                  row.enabled ? 'bg-white' : 'bg-slate-50/60'
                }`}
              >
                <label className="flex min-w-0 items-center gap-2.5">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-slate-300 text-[#2f6fd4] focus:ring-[#2f6fd4]"
                    checked={Boolean(row.enabled)}
                    disabled={disabled}
                    onChange={(e) => updateRow(row.category, { enabled: e.target.checked })}
                  />
                  <span
                    className={`truncate text-sm font-medium ${
                      row.enabled ? 'text-[#0f3350]' : 'text-slate-500'
                    }`}
                  >
                    {label}
                  </span>
                </label>
                <input
                  type="number"
                  min={0}
                  disabled={disabled || !row.enabled}
                  value={row.min_amount}
                  onChange={(e) => updateRow(row.category, { min_amount: e.target.value })}
                  placeholder={t('assistanceManagement.placeholderMin')}
                  className="w-full rounded-lg border border-gray-300 px-2 py-1.5 text-sm disabled:bg-slate-100 disabled:text-slate-400"
                />
                <input
                  type="number"
                  min={0}
                  disabled={disabled || !row.enabled}
                  value={row.max_amount}
                  onChange={(e) => updateRow(row.category, { max_amount: e.target.value })}
                  placeholder={t('assistanceManagement.placeholderMax')}
                  className="w-full rounded-lg border border-gray-300 px-2 py-1.5 text-sm disabled:bg-slate-100 disabled:text-slate-400"
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
